<template>
  <div class="notifications">
    <div
      v-show="!hideTitle"
      class="header"
    >
      <h3>
        {{ $t('siteDashboard.notifications') }}
      </h3>

      <router-link
        to="/alertsNotifications"
      >
        <img
          class="redirect-icon"
          src="/dashboard/routeTo.svg"
        >
      </router-link>
    </div>

    <div class="notifications-list">
      <Notification
        v-for="notification in latestNotifications"
        :key="notification.id"
        :notification="notification"
        :siteId="site.id"
      />
    </div>

    <div
      v-if="latestNotifications.length < 1"
      class="no-alerts"
    >
      {{ $t('siteDashboard.noAlerts') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Notification from './Notification.vue';


export default {
    name: 'Notifications',

    components: {
        Notification,
    },
    props: {
        hideTitle: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
            notifications: [],
        };
    },

    computed: {
        ...mapGetters([
            'lang',
            'site',
        ]),

        latestNotifications() {
            return this.notifications.slice(0, 4);
        },
    },

    async created() {
        await this.getNotifications();
    },

    methods: {
        async getNotifications() {
            const { data } = await this.$rq.getAllNotificationsBySite(this.site.id);

            this.notifications = data.alertsNotifications;
        },
    },
};
</script>

<style lang="scss" scoped>
.notifications {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    background: #FFF;
    border-radius: 7px;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        width: 100%;
        padding: 6px;

        background: #DEDEDE;
        border-radius: 7px 7px 0px 0px;
    }

    h3 {
        display: flex;
        justify-content: center;

        width: 100%;

        font-size: 16px;
        font-weight: 400;
        text-transform: capitalize;
        text-align: center;
    }

    .redirect-icon {
        display: flex;
        width: 16px;
        height: 16px;
    }

    .notifications-list {
        width: 100%;
    }

    .no-alerts {
        padding: 20px;

        color: rgba(20, 20, 20, 0.25);

        font-size: 12px;
        text-align: center;
    }
}
</style>
